import JellyBelly from './JellyBelly';

export default {
    datatable(selector, path, data, callback, config) {
        let table = this.get(selector);

        JellyBelly.stream(
            path,
            data,
            (json, stop) => {
                if (json) {
                    if (json.what === 'row') {
                        table.tbody.insertAdjacentHTML('beforeEnd', json.data.html ? json.data.html : json.data);
                    } else if (json.what === 'rows') {
                        json.data.forEach((row) => {
                            table.tbody.insertAdjacentHTML('beforeEnd', row.html ? row.html : row);
                        });
                    }
                }

                if (stop) {
                    $(table.dom).DataTable(config);
                }

                callback(json, stop);
            }
        );
    },

    get(table) {
        let dom = document.querySelector(table);

        if (!dom) {
            throw new Error(`Table "${table}" not found.`);
        }

        return {
            dom:     dom,
            tbody:   dom.querySelector('tbody'),
            thead:   dom.querySelector('thead'),
            wrapper: dom.closest('.table-responsive'),
        };
    }
};
